import { PERMISSIONS } from "@/constants/permissions";

export const contactQueryTableColumns = [
  { name: "#" },
  { name: "Date", class: "hidden sm:table-cell" },
  { name: "Name" },
  { name: "Contacts" },
  { name: "Message" },
  {
    name: "Actions",
    class: "text-right",
    requirePermissionList: [PERMISSIONS.CONTACTS.DELETE_CONTACT_QUERY],
  },
];

export const newsArticleTableColumns = [
  { name: "#" },
  { name: "Date", class: "hidden sm:table-cell text-center" },
  { name: "Banner", class: "text-center" },
  { name: "Title", class: "text-center" },
  {
    name: "Actions",
    class: "text-right",
    requirePermissionList: [
      PERMISSIONS.NEWS.EDIT_NEWS_ARTICLE,
      PERMISSIONS.NEWS.DELETE_NEWS_ARTICLE,
      PERMISSIONS.NEWS.TOGGLE_ACTIVE_NEWS_ARTICLE,
      PERMISSIONS.NEWS.TOGGLE_FEATURED_NEWS_ARTICLE,
    ],
  },
];

export const coursesTableColumns = [
  { name: "#" },
  { name: "Image" },
  { name: "Title" },
  { name: "Short Description" },
  {
    name: "Actions",
    class: "text-right",
    requirePermissionList: [
      PERMISSIONS.COURSES.EDIT_COURSE,
      PERMISSIONS.COURSES.DELETE_COURSE,
      PERMISSIONS.COURSES.TOGGLE_ACTIVE_COURSE,
      PERMISSIONS.COURSES.TOGGLE_FEATURED_COURSE,
    ],
  },
];

export const coursePackagesTableColumns = [
  { name: "#" },
  { name: "Name" },
  { name: "Course Name" },
  { name: "Type" },
  { name: "Info" },
  {
    name: "Actions",
    class: "text-right",
    requirePermissionList: [
      PERMISSIONS.PACKAGES.EDIT_PACKAGE,
      PERMISSIONS.PACKAGES.DELETE_PACKAGE,
      PERMISSIONS.PACKAGES.TOGGLE_ACTIVE_PACKAGE,
      PERMISSIONS.PACKAGES.TOGGLE_FEATURED_PACKAGE,
    ],
  },
];

export const cmsPageTableColumns = [
  { name: "#" },
  { name: "Name" },
  { name: "Slug" },
  {
    name: "Actions",
    class: "text-right",
    requirePermissionList: [
      PERMISSIONS.CMS_SETUP.EDIT_PAGE,
      PERMISSIONS.CMS_SETUP.EDIT_PAGE_SECTIONS,
      PERMISSIONS.CMS_SETUP.TOGGLE_ACTIVE_PAGE,
    ],
  },
];

export const contactsTableColumns = [
  { name: "#" },
  { name: "Name" },
  { name: "Address" },
  {
    name: "Actions",
    class: "text-right",
    requirePermissionList: [
      PERMISSIONS.CONTACTS.EDIT_CONTACT,
      PERMISSIONS.CONTACTS.DELETE_CONTACT,
      PERMISSIONS.CONTACTS.TOGGLE_ACTIVE_CONTACT,
      PERMISSIONS.CONTACTS.TOGGLE_ACTIVE_CONTACT_FORM,
      PERMISSIONS.CONTACTS.TOGGLE_FEATURED_CONTACT,
    ],
  },
];

export const testimonialsTableColumns = [
  { name: "#" },
  { name: "Image", class: "hidden sm:table-cell text-center" },
  { name: "Name", class: "text-center" },
  { name: "Rating", class: "text-center" },
  {
    name: "Actions",
    class: "text-right",
    requirePermissionList: [
      PERMISSIONS.TESTIMONIAL.EDIT_TESTIMONIAL,
      PERMISSIONS.TESTIMONIAL.DELETE_TESTIMONIAL,
      PERMISSIONS.TESTIMONIAL.TOGGLE_ACTIVE_TESTIMONIAL,
      PERMISSIONS.TESTIMONIAL.TOGGLE_FEATURED_TESTIMONIAL,
    ],
  },
];

export const notificationsTableColumns = [
  { name: "#" },
  { name: "Text", class: "text-center" },
  {
    name: "Actions",
    class: "text-right",
    requirePermissionList: [
      PERMISSIONS.NOTIFICATION.EDIT_NOTIFICATION,
      PERMISSIONS.NOTIFICATION.DELETE_NOTIFICATION,
      PERMISSIONS.NOTIFICATION.TOGGLE_ACTIVE_NOTIFICATION,
    ],
  },
];

export const servicesTableColumns = [
  { name: "#" },
  { name: "Date", class: "hidden sm:table-cell text-center" },
  { name: "Image", class: "text-center" },
  { name: "Name", class: "text-center" },
  {
    name: "Actions",
    class: "text-right",
    requirePermissionList: [
      PERMISSIONS.SERVICE.EDIT_SERVICE,
      PERMISSIONS.SERVICE.DELETE_SERVICE,
      PERMISSIONS.SERVICE.TOGGLE_ACTIVE_SERVICE,
      PERMISSIONS.SERVICE.TOGGLE_FEATURED_SERVICE,
    ],
  },
];

export const investmentsTableColumns = [
  { name: "#" },
  { name: "Date", class: "hidden sm:table-cell text-center" },
  { name: "Name", class: "text-center" },
  { name: "Image", class: "text-center" },
  {
    name: "Actions",
    class: "text-right",
    requirePermissionList: [
      PERMISSIONS.INVESTMENT.EDIT_INVESTMENT,
      PERMISSIONS.INVESTMENT.DELETE_INVESTMENT,
      PERMISSIONS.INVESTMENT.TOGGLE_ACTIVE_INVESTMENT,
      PERMISSIONS.INVESTMENT.TOGGLE_FEATURED_INVESTMENT,
    ],
  },
];

export const careersTableColumns = [
  { name: "#" },
  { name: "Date", class: "text-center" },
  { name: "Job Title", class: "text-center" },
  {
    name: "Actions",
    class: "text-right",
    requirePermissionList: [
      PERMISSIONS.CAREER.EDIT_CAREER,
      PERMISSIONS.CAREER.DELETE_CAREER,
      PERMISSIONS.CAREER.TOGGLE_ACTIVE_CAREER,
      PERMISSIONS.CAREER.TOGGLE_FEATURED_CAREER,
    ],
  },
];

export const faqCategoryTableColumns = [
  {
    name: "#",
  },
  {
    name: "Name",
  },
  {
    name: "Slug",
  },
  {
    name: "Actions",
    class: "text-right",
    requirePermissionList: [
      PERMISSIONS.FAQ_CATEGORY.EDIT_FAQ_CATEGORY,
      PERMISSIONS.FAQ_CATEGORY.DELETE_FAQ_CATEGORY,
      PERMISSIONS.FAQ_CATEGORY.TOGGLE_ACTIVE_FAQ_CATEGORY,
      PERMISSIONS.FAQ_CATEGORY.TOGGLE_DEFAULT_FAQ_CATEGORY,
    ],
  },
];

export const faqsTableColumns = [
  {
    name: "#",
  },
  {
    name: "Question",
    class: "text-center",
  },
  {
    name: "Category",
    class: "text-center",
  },
  {
    name: "Actions",
    class: "text-right",
    requirePermissionList: [
      PERMISSIONS.FAQ.EDIT_FAQ,
      PERMISSIONS.FAQ.DELETE_FAQ,
      PERMISSIONS.FAQ.TOGGLE_ACTIVE_FAQ,
      PERMISSIONS.FAQ.TOGGLE_FEATURED_FAQ,
    ],
  },
];

export const mediaPhotoTableColumns = [
  { name: "#" },
  { name: "Date", class: "text-center" },
  { name: "Iamge", class: "text-center" },
  {
    name: "Actions",
    class: "text-right",
    requirePermissionList: [
      PERMISSIONS.PHOTO_MEDIA.EDIT_PHOTO,
      PERMISSIONS.PHOTO_MEDIA.DELETE_PHOTO,
      PERMISSIONS.PHOTO_MEDIA.TOGGLE_ACTIVE_PHOTO,
      PERMISSIONS.PHOTO_MEDIA.TOGGLE_FEATURED_PHOTO,
    ],
  },
];

export const mediaVideoTableColumns = [
  { name: "#" },
  { name: "Date", class: "text-center" },
  { name: "Title", class: "text-center" },
  { name: "Image", class: "text-center" },
  {
    name: "Actions",
    class: "text-right",
    requirePermissionList: [
      PERMISSIONS.VIDEO_MEDIA.EDIT_VIDEO,
      PERMISSIONS.VIDEO_MEDIA.DELETE_VIDEO,
      PERMISSIONS.VIDEO_MEDIA.TOGGLE_ACTIVE_VIDEO,
    ],
  },
];

export const mediaMovieTableColumns = [
  { name: "#" },
  { name: "Date", class: "text-center" },
  { name: "Title", class: "text-center" },
  { name: "Iamge", class: "text-center" },
  {
    name: "Actions",
    class: "text-right",
    requirePermissionList: [
      PERMISSIONS.MOVIE_MEDIA.EDIT_MOVIE,
      PERMISSIONS.MOVIE_MEDIA.DELETE_MOVIE,
      PERMISSIONS.MOVIE_MEDIA.TOGGLE_ACTIVE_MOVIE,
    ],
  },
];

export const newsCategoryTableColumns = [
  { name: "Name" },
  {
    name: "Actions",
    class: "md:hidden text-right",
    requirePermissionList: [
      PERMISSIONS.NEWS_CATEGORY.EDIT_NEWS_CATEGORY,
      PERMISSIONS.NEWS_CATEGORY.DELETE_NEWS_CATEGORY,
      PERMISSIONS.NEWS_CATEGORY.TOGGLE_ACTIVE_NEWS_CATEGORY,
      PERMISSIONS.NEWS_CATEGORY.TOGGLE_FEATURED_NEWS_CATEGORY,
      PERMISSIONS.NEWS_CATEGORY.TOGGLE_DEFAULT_NEWS_CATEGORY,
    ],
  },
  {
    name: "Active Status",
    class: "hidden md:table-cell",
    requirePermissionList: [
      PERMISSIONS.NEWS_CATEGORY.TOGGLE_ACTIVE_NEWS_CATEGORY,
    ],
  },
  {
    name: "Featured Status",
    class: "hidden md:table-cell",
    requirePermissionList: [
      PERMISSIONS.NEWS_CATEGORY.TOGGLE_FEATURED_NEWS_CATEGORY,
    ],
  },
  {
    name: "Default Status",
    class: "hidden md:table-cell",
    requirePermissionList: [
      PERMISSIONS.NEWS_CATEGORY.TOGGLE_DEFAULT_NEWS_CATEGORY,
    ],
  },
  {
    name: "Options",
    class: "hidden md:table-cell text-right",
    requirePermissionList: [
      PERMISSIONS.NEWS_CATEGORY.EDIT_NEWS_CATEGORY,
      PERMISSIONS.NEWS_CATEGORY.DELETE_NEWS_CATEGORY,
    ],
  },
];

export const roleTableColumns = () => [
  { name: "#" },
  { name: "Name" },
  {
    name: "Options",
    class: "text-right",
    requirePermissionList: [
      PERMISSIONS.STAFF.EDIT_STAFF_ROLE,
      PERMISSIONS.STAFF.DELETE_STAFF_ROLE,
    ],
  },
];

export const userTableColumns = () => [
  { name: "#", class: "pl-3" },
  { name: "Name" },
  { name: "Email" },
  { name: "Roles" },
  {
    name: "Options",
    class: "text-right pr-3",
    requirePermissionList: [
      PERMISSIONS.STAFF.EDIT_STAFF,
      PERMISSIONS.STAFF.DELETE_STAFF,
    ],
  },
];

export const languagesTableColumns = () => [
  { name: "#" },
  { name: "Name" },
  {
    name: "Actions",
    class: "md:hidden text-right",
    requirePermissionList: [
      PERMISSIONS.LANGUAGE.EDIT_LANGUAGE,
      PERMISSIONS.LANGUAGE.DELETE_LANGUAGE,
      PERMISSIONS.LANGUAGE.TOGGLE_ACTIVE_LANGUAGE,
      PERMISSIONS.LANGUAGE.TOGGLE_RTL_LANGUAGE,
      PERMISSIONS.LANGUAGE.TOGGLE_DEFAULT_LANGUAGE,
    ],
  },
  {
    name: "Active Status",
    class: "hidden md:table-cell",
    requirePermissionList: [PERMISSIONS.LANGUAGE.TOGGLE_ACTIVE_LANGUAGE],
  },
  {
    name: "RTL Status",
    class: "hidden md:table-cell",
    requirePermissionList: [PERMISSIONS.LANGUAGE.TOGGLE_RTL_LANGUAGE],
  },
  {
    name: "Default Status",
    class: "hidden md:table-cell",
    requirePermissionList: [PERMISSIONS.LANGUAGE.TOGGLE_DEFAULT_LANGUAGE],
  },
  {
    name: "Options",
    class: "hidden md:table-cell text-right",
    requirePermissionList: [
      PERMISSIONS.LANGUAGE.EDIT_LANGUAGE,
      PERMISSIONS.LANGUAGE.DELETE_LANGUAGE,
    ],
  },
];

export const menuTableColumns = () => [
  { name: "Name" },
  {
    name: "Actions",
    class: "md:hidden text-right",
    requirePermissionList: [
      PERMISSIONS.MENU_MANAGEMENT.EDIT_MENU,
      PERMISSIONS.MENU_MANAGEMENT.DELETE_MENU,
      PERMISSIONS.MENU_MANAGEMENT.TOGGLE_ACTIVE_MENU,
      PERMISSIONS.MENU_MANAGEMENT.TOGGLE_PRODUCT_MENU,
    ],
  },
  {
    name: "Active Status",
    class: "hidden md:table-cell",
    requirePermissionList: [PERMISSIONS.MENU_MANAGEMENT.TOGGLE_ACTIVE_MENU],
  },
  // {
  //   name: "Product Menu Status",
  //   class: "hidden md:table-cell",
  //   requirePermissionList: [PERMISSIONS.MENU_MANAGEMENT.TOGGLE_PRODUCT_MENU],
  // },
  {
    name: "Options",
    class: "hidden md:table-cell text-right",
    requirePermissionList: [
      PERMISSIONS.MENU_MANAGEMENT.EDIT_MENU,
      PERMISSIONS.MENU_MANAGEMENT.DELETE_MENU,
    ],
  },
];

export const businessLeadsTableColumns = [
  { name: "#" },
  { name: "Date" },
  { name: "Business Name" },
  { name: "User Details" },
  { name: "Message" },
];

export const businessClubLeadsTableColumns = [
  { name: "#" },
  { name: "Date" },
  { name: "Slot" },
  { name: "User Details" },
  { name: "Message" },
];

export const careerLeadsTableColumns = [
  { name: "#" },
  { name: "Date" },
  { name: "User Details" },
  { name: "Resume" },
  { name: "Message" },
];

export const consultingLeadsTableColumns = [
  { name: "#" },
  { name: "Date" },
  { name: "Slot" },
  { name: "User Details" },
  { name: "Meeting Mode" },
  { name: "Message" },
];

export const generalLeadsTableColumns = [
  { name: "#" },
  { name: "Date" },
  { name: "User Details" },
  { name: "Message" },
];

export const partnershipLeadsTableColumns = [
  { name: "#" },
  { name: "Date" },
  { name: "Company Name" },
  { name: "User Details" },
  { name: "Message" },
];

export const serviceLeadsTableColumns = [
  { name: "#" },
  { name: "Date" },
  { name: "Service Name" },
  { name: "User Details" },
  { name: "Message" },
];
